import { createSlice } from '@reduxjs/toolkit';

export const jobsSlice = createSlice({
  name: 'jobs',
  initialState: {
    results: {},
    pageSize: 10,
    page: 0,
    currentSoc: '',
    activeSoc: '',
    availableFilters: ['careerPathName', 'nearby', 'partTime'],
    activeFilters: ['careerPathName']
  },
  reducers: {
    setJobs: (state, action) => {
      state.results = action.payload;
    },
    setActiveSoc: (state, action) => {
      state.activeSoc = action.payload;
    },
    setCurrentSoc: (state, action) => {
      state.currentSoc = action.payload;
    },
    setActiveFilters: (state, action) => {
      state.activeFilters = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setJobs, setActiveSoc, setCurrentSoc, setActiveFilters, setPage } = jobsSlice.actions;

export default jobsSlice.reducer;